import { companyValues } from '@/configs/translates.config';

export default {
	'add-new-company-value': `add new ${companyValues.en.singular}`,
	'the-company-value': `the ${companyValues.en.singular}?`,
	'company-value': companyValues.en.singular,
}